module.exports = __webpack_public_path__ + "img/guide-img-02.9ebdf384.png";